<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: string;
    label: string;
    readonly?: boolean;
    placeholder?: string;
    fieldType?: 'text' | 'password';
    error?: boolean;
    errorNote?: string;
  }>(),
  {
    readonly: false,
    error: false,
    fieldType: 'text',
    placeholder: '',
    errorNote: '',
  }
);

const emit = defineEmits(['update:modelValue']);

const updateValue = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.value);
};
</script>

<template>
  <div class="tppr-text-field flex-1" :class="{ error: props.error }">
    <span class="tppr-text-field__title text-gray-700 dark:text-gray-500">{{ label }}</span>
    <div class="tppr-text-field__field-container">
      <input :type="props.fieldType" :value="props.modelValue" :placeholder="props.placeholder" :readonly="props.readonly" @input="updateValue" />
    </div>
    <span v-if="props.errorNote" class="tppr-text-field__note">{{ props.errorNote }}</span>
  </div>
</template>
